module.exports = __webpack_public_path__ + "img/photo-59.b579c142.webp";